import type { IAction } from '../../action/IAction'
import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action'
import { Metadata } from '../../base'

@InputType()
export class CreateBankTransferArgs extends ActionArgs {
  @Field(() => Number)
  amount: number

  @Field(() => String, { nullable: true })
  existingStripeId?: string

  @Field(() => String, { nullable: true })
  email?: string

  @Field(() => String, { nullable: true })
  name?: string

  @Field(() => Metadata)
  metadata: Metadata
}

export type CreateBankTransferBankInfo = {
  bankName?: string
  routingNumber?: string
  accountNumber?: string
  swiftCode?: string
  reference?: string
}

export type CreateBankTransferResult = {
  paymentIntent: any
  customerId: string
  bankInfo: CreateBankTransferBankInfo
}

export interface ICreateBankTransfer extends IAction<CreateBankTransferResult, CreateBankTransferArgs> {}
